/* eslint-disable @next/next/no-img-element */
'use client';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';
import { type ItemValue, type QuestionCheckboxModel } from 'survey-core';

import { useNullableDataProvider } from '@/components/flow/components/DataProvider/useNullableDataProvider';
import { DATA_KEYS } from '@/consts/dataKeys';

import { calculateAge } from '../../utils/compareAgeByDate';
import CheckboxImageItem from '../checkboxImageItem';
import CheckboxItem from '../checkboxItem';

type QuestionCategory = {
  name: string;
  title: string;
};

const CheckboxQuestion = ({
  question,
}: {
  question: QuestionCheckboxModel;
}) => {
  const eligibilityData = useNullableDataProvider(DATA_KEYS.eligibilityData);
  const isUserAboveAge35 = eligibilityData?.birthdate
    ? calculateAge(eligibilityData.birthdate) > 35
    : false;

  return question.categories?.length > 0 ? (
    <div className="cur-flex cur-flex-col cur-gap-3">
      {question.categories.map((category: QuestionCategory) => {
        const orderProp = isUserAboveAge35
          ? 'orderAboveAge35'
          : 'orderBelowAge35';

        const orderedChoices = question.choices
          .filter((choice) => choice.category === category.name)
          .sort((a, b) => a[orderProp] - b[orderProp]);

        return (
          <div key={category.name}>
            <div>
              {category.title && (
                <>
                  <Typography className="cur-font-bold cur-leading-normal cur-mb-3">
                    {category.title}
                  </Typography>
                </>
              )}

              <div
                role="presentation"
                className="cur-text-primary cur-input-imagepicker cur-gap-3 cur-grid cur-grid-cols-3"
              >
                {orderedChoices.map((choice) =>
                  choice.component === 'image-card' ? (
                    <CheckboxImageItem
                      key={choice.value}
                      question={question}
                      item={choice}
                    />
                  ) : (
                    <CheckboxItem
                      key={choice.value}
                      question={question}
                      item={choice}
                    />
                  ),
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  ) : (
    <div
      role="presentation"
      className="cur-text-primary cur-input-radiogroup cur-space-y-4"
    >
      {question.descriptionImage && (
        <img alt={question.name} src={question.descriptionImage} />
      )}
      {question.choices
        .filter((choice: ItemValue) => choice.visible)
        .map((choice: ItemValue) => (
          <CheckboxItem key={choice.value} question={question} item={choice} />
        ))}
    </div>
  );
};

export default CheckboxQuestion;
